import { AutogenLayoutCarrierOfferQuickInfo } from "./autogen/AutogenLayoutCarrierOfferQuickInfo";

export class CarrierOfferQuickInfo extends AutogenLayoutCarrierOfferQuickInfo {

    sourceCarrierOfferHistoryOnDisplay(event) {
        this.panelContactName.visible = this.mainDataSource.activeRow?.get("contact_name") != null;
    }
}
